import ReleaseContainer from "./ReleaseContainer";

function Release() {
  return <ReleaseContainer />;
}

export default Release;
